import { render, staticRenderFns } from "./ControlList.vue?vue&type=template&id=63ddeb70&"
import script from "./ControlList.vue?vue&type=script&lang=js&"
export * from "./ControlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports